// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1q0t4","question":"styles_question__gSo-p","inputVisibleButton":"styles_inputVisibleButton__38oB4","note":"styles_note__plO9V"};